<ng-select matInput
    [class]="field.className   || ''"
    [items]="props.options | formlySelectOptions:field|async"
    [appearance]="props.appearance || ''"
    [bindValue]="props.bindValue || 'value'"
    [bindLabel]="props.bindLabel || 'label'"
    [notFoundText]="props?.notFoundText || 'Enter text'"
    [addTagText]="props?.addTagText || 'Add text'"
    [placeholder]="props?.placeholder || 'Enter text'"
    [readonly]="props?.readonly || false"
    [addTag]="props?.addTag === false ? false :  addTagFn"
    [multiple]="props?.multiple || false"
    [searchable]="props?.searchable || false"
    [clearable]="props?.clearable || false"
    [formControl]="formControl">
</ng-select>
<!-- | formlySelectOptions:field|async -->